module.exports = __webpack_public_path__ + "static/media/PhaserGame.83723479.webp";